module.exports = __webpack_public_path__ + "static/media/sylwia-olejniczak.3b1b421d.png";